<template>
    <component
        :is="module.type"
        :d="module.data"
        v-for="(module, index) in modules"
        :key="index"
        :class="getModuleClass(module)"
    ></component>
</template>

<script setup>
    import { onMounted, defineExpose } from 'vue';
    import { app } from '@/app'
    import { masterForm } from '../mixins/masterForm';

    const props = defineProps({ modules: Object })
    const requireModule = require.context('@/modules', false, /\.vue$/)

    const getModuleClass = module => {
        return ['module', module.data.padding_top, module.data.padding_bottom].filter(Boolean).join(' ')
    }

    const { default: emptyModule } = requireModule(`./empty_module.vue`)

    // Apply mixins or do other setup logic
    const applyMixins = () => {
        Object.assign({}, masterForm)
    }

    // Expose properties and methods to the template
    defineExpose({
        getModuleClass,
        applyMixins
    })

    props.modules.forEach(module => {
        const moduleName = module.type.toLowerCase()

        if (!app._context.components[moduleName]) {
            try {
                const { default: moduleConfig } = requireModule(`./${moduleName}.vue`)
                app.component(moduleName, moduleConfig)
            } catch (error) {
                app.component(moduleName, emptyModule)
                console.error(`Failed to import module ${moduleName}:`, error);
            }
        }
    })

    // Apply mixins or do other setup logic when the component is mounted
    onMounted(() => {
        applyMixins()
    })
</script>